<template>
  <Layout>
    <section class="csms-notice">

      <!-- Page Title Start -->
      <PageHeader :title="title" />
      <!-- Page Title End -->

      <!-- Search Area Start -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

              <div class="row">
                <!-- // Search Input -->
                <div class="col-xl-10 ion-mb-mb-100">
                  <div class="row">
                    <div class="col-xl-3">
                      <label class="form-label" for="notice-search-system">{{ $t('terms.appCsmsType') }}</label>
                      <multiselect id="notice-search-system"
                                   v-model="searchForm.appCsmsType"
                                   label="text" track-by="value"
                                   :options="systemTypeOptions"
                                   selectLabel=""
                                   selectedLabel=""
                                   deselectLabel=""
                                   :searchable="false" :allow-empty="false" />
                    </div>
                    <div class="col-xl-3">
                      <label class="form-label" for="notice-search-type">{{ $t('notice.noticeType') }}</label>
                      <multiselect id="notice-search-type"
                                   label="text" track-by="value"
                                   v-model="searchForm.noticeType"
                                   :options="noticeTypeOptions"
                                   selectLabel=""
                                   selectedLabel=""
                                   deselectLabel=""
                                   :searchable="false" :allow-empty="false" />
                    </div>
                    <div class="col-xl-3">
                      <label for="notice-search-title" class="form-label">{{ $t('notice.title') }}</label>
                      <b-form-input class="form-control" type="text" id="notice-search-title"
                                    v-model="searchForm.title" />
                    </div>
                    <div class="col-xl-3">
                      <label for="notice-search-contents" class="form-label">{{ $t('notice.contents') }}</label>
                      <b-form-input class="form-control" type="text" id="notice-search-contents"
                                    v-model="searchForm.contents" />
                    </div>
                  </div>
                </div>
                <!-- // Search Button -->
                <div class="col-xl-2 align-content-end">
                  <div class="float-end">
                    <b-button variant="secondary" class="me-3" @click="reset">
                      <i class="uil uil-redo me-2"></i>
                      <span>{{ $t('btn.reset') }}</span>
                    </b-button>
                    <b-button variant="primary" @click="search">
                      <i class="uil uil-search me-2"></i>
                      <span>{{ $t('btn.search') }}</span>
                    </b-button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- Search Area End -->

      <!-- List Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-3 align-items-end">
                <!-- // List PerPage Count -->
                <div class="col-auto">
                  <PerPageSelector v-model="pagination.perPage"
                                   :option="[50, 100, 200]"
                                   @change="onPerPageChange" />
                </div>
                <!-- // Total Count -->
                <div class="col me-2">
                  <div class="float-end">
                    <total-count :total-count="pagination.totalCount" />
                  </div>
                </div>
              </div>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         show-empty :empty-text="$t('notice.noNotice')"
                         :fields="fields" :items="items">
                  <template #head()="data">
                    <span v-if="!$_utils.isEmpty(data.label)">{{ $t(`notice.${data.column}`) }}</span>
                  </template>

                  <template #cell(checkbox)="data">
                    <input type="checkbox" class="form-check-input"
                           v-model="selectedNotice" :value="data.item.noticeId">
                  </template>
                  <template #cell(noticeType)="data">
                    {{ $_formatter.noticeTypeName(data.item.noticeType) }}
                  </template>
                  <template #cell(title)="data">
                    <a href="#" @click="viewModal(data.item.noticeId)">{{ $_utils.textLengthOverCut(data.item.title, 40, null) }}</a>
                  </template>
                  <template #cell(isPublish)="data">
                    {{ data.item.isPublish ? $t('common.open') : $t('common.private') }}
                  </template>
                  <template #cell(etc)="data">
                    <button class="btn btn-sm btn-warning w-sm" @click="editModal(data.item.noticeId)">{{ $t('btn.edit') }}</button>
                  </template>
                </b-table>
              </div>

              <!-- // Pagination -->
              <div class="row mt-3">
                <div class="col-xl-12">
                  <b-pagination size="sm" class="mb-0" align="center"
                                :total-rows="pagination.totalCount"
                                :per-page="pagination.perPage"
                                v-model="pagination.currentPage"
                                @change="onPageChange" />
                </div>
              </div>

              <!-- Bottom Button Start -->
              <div class="row ion-mb-mt-100">
                <div class="col-xl-12">
                  <div class="float-start">
                    <b-button variant="danger" @click="del">
                      <i class="uil uil-minus me-2"></i>
                      <span>{{ $t('btn.delete') }}</span>
                    </b-button>
                  </div>
                  <div class="float-end">
                    <b-button variant="success" @click="create">
                      <i class="uil uil-plus me-2"></i>
                      <span>{{ $t('btn.create') }}</span>
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- Bottom Button End -->

            </div>
          </div>
        </div>
      </div>
      <!-- List End -->

      <create-modal ref="noticeCreateModal" @callback="getItems" />
      <view-modal ref="noticeViewModal" :selected-id="selectedId" @callback="getItems" />
      <edit-modal ref="noticeEditModal" :selected-id="selectedId" @callback="getItems" />
    </section>
  </Layout>
</template>

<script>
import { http } from '@/auth-api';
import { loadingMethods } from '@/state/helpers';
import i18n from '@/i18n';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import Layout from '@/views/layouts/Main.vue';
import PageHeader from '@/components/PageHeader.vue';
import PerPageSelector from '@/views/components/PerPageSelector.vue';
import TotalCount from '@/views/components/TotalCount.vue';
import CreateModal from '@/views/pages/notice/NoticeCreateModal.vue';
import ViewModal from '@/views/pages/notice/NoticeViewModal.vue';
import EditModal from '@/views/pages/notice/NoticeEditModal.vue';

export default {
  components: {
    Multiselect, Layout, PageHeader, PerPageSelector, TotalCount, CreateModal, ViewModal, EditModal
  },
  data() {
    return {
      title: 'notice',
      selectedId: null,
      selectedNotice: [],
      systemTypeOptions: [
        { text: i18n.t('common.total'), value: null },
        { text: 'APP', value: 'APP' },
        { text: 'CSMS', value: 'CSMS' },
      ],
      noticeTypeOptions: [
        { text: i18n.t('common.total'), value: null },
        { text: i18n.t('common.general'), value: 'General' },
        { text: i18n.t('common.urgent'), value: 'Urgent' },
      ],
      searchConditions: [
        { 'searchKey': 'contentType', 'searchValue': 'notice' }
      ],
      sortDirection: 'DESC',
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      searchForm: {
        appCsmsType: { text: i18n.t('common.total'), value: null },
        noticeType: { text: i18n.t('common.total'), value: null },
        title: null,
        contents: null
      },
      fields: [
        { key: 'checkbox', label: '', class: 'text-center' },
        { key: 'rnum', label: 'No.', class: 'text-center' },
        { key: 'appCsmsType', label: '시스템', class: 'text-center' },
        { key: 'noticeType', label: '공지 구분', class: 'text-center' },
        { key: 'title', label: '제목', class: 'text-center' },
        { key: 'isPublish', label: '공개 여부', class: 'text-center' },
        { key: 'created', label: '등록일', class: 'text-center' },
        { key: 'updated', label: '수정일', class: 'text-center' },
        { key: 'etc', label: '', class: 'text-center' }
      ],
      items: null
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    ...loadingMethods,
    reset() {
      const vm = this;

      vm.selectedId = null;
      vm.searchForm = {
        appCsmsType: { text: i18n.t('common.total'), value: null },
        noticeType: { text: i18n.t('common.total'), value: null },
        title: null,
        contents: null
      };
      vm.searchConditions = [
        { 'searchKey': 'contentType', 'searchValue': 'notice' },
      ];

      vm.getItems();
    },
    search() {
      const vm = this;

      vm.searchConditions = [{ 'searchKey': 'contentType', 'searchValue': 'notice' }];

      if (!this.$_utils.isEmpty(vm.searchForm.appCsmsType.value)) {
        vm.searchConditions.push({ searchKey: 'appCsmsType', searchValue: vm.searchForm.appCsmsType.value });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.noticeType.value)) {
        vm.searchConditions.push({ searchKey: 'noticeType', searchValue: vm.searchForm.noticeType.value });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.title)) {
        vm.searchConditions.push({ searchKey: 'title', searchValue: vm.searchForm.title });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.contents)) {
        vm.searchConditions.push({ searchKey: 'contents', searchValue: vm.searchForm.contents });
      }

      vm.pagination.currentPage = 1;
      vm.getItems();

      /*if (this.$_utils.isEmpty(vm.searchForm.appCsmsType.value)
          && this.$_utils.isEmpty(vm.searchForm.noticeType.value)
          && this.$_utils.isEmpty(vm.searchForm.title)
          && this.$_utils.isEmpty(vm.searchForm.contents)) {
        Swal.fire({
          icon: 'warning',
          title: i18n.t('alert.searchConditions'),
          confirmButtonText: i18n.t('btn.close')
        });
      } else {
        vm.searchConditions = [{ 'searchKey': 'contentType', 'searchValue': 'notice' }];

        if (!this.$_utils.isEmpty(vm.searchForm.appCsmsType.value)) {
          vm.searchConditions.push({ searchKey: 'appCsmsType', searchValue: vm.searchForm.appCsmsType.value });
        }

        if (!this.$_utils.isEmpty(vm.searchForm.noticeType.value)) {
          vm.searchConditions.push({ searchKey: 'noticeType', searchValue: vm.searchForm.noticeType.value });
        }

        if (!this.$_utils.isEmpty(vm.searchForm.title)) {
          vm.searchConditions.push({ searchKey: 'title', searchValue: vm.searchForm.title });
        }

        if (!this.$_utils.isEmpty(vm.searchForm.contents)) {
          vm.searchConditions.push({ searchKey: 'contents', searchValue: vm.searchForm.contents });
        }

        vm.pagination.currentPage = 1;
        vm.getItems();
      }*/
    },
    async getItems() {
      const vm = this;
      const _url = '/onmapi/view/Notice/list';

      vm.showOverlay();

      await http.post(_url, {
        page: vm.pagination.currentPage,
        limit: vm.pagination.perPage,
        searchConditions: vm.searchConditions,
        sortCondition: { sortDirection: vm.sortDirection }
      }).then(res => {
        vm.items = res.data.items;
        vm.pagination.totalCount = res.data.totalCount;
      }).catch(err => {
        console.error('Notice List Error :: ', err)
      });

      vm.hideOverlay();
    },
    async onPerPageChange() {
      const vm = this;

      if (vm.pagination.totalCount > 1) {
        vm.pagination.currentPage = 1;
        await vm.getItems();
      }
    },
    async onPageChange(val) {
      const vm = this;
      vm.pagination.currentPage = val;

      if (vm.pagination.totalCount > 1) {
        await vm.getItems();
      }
    },
    create() {
      const vm = this;

      vm.$nextTick(() => {
        this.$refs.noticeCreateModal.show();
      });
    },
    viewModal(id) {
      const vm = this;
      vm.selectedId = id;

      this.$nextTick(() => {
        this.$refs.noticeViewModal.show();
      });
    },
    editModal(id) {
      const vm = this;
      vm.selectedId = id;

      this.$nextTick(() => {
        this.$refs.noticeEditModal.show();
      });
    },
    del() {
      const vm = this;

      if (vm.selectedNotice.length < 1) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('alert.selectNotice'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      } else {
        Swal.fire({
          title: i18n.t('alert.confirmDelete'),
          showCancelButton: true,
          confirmButtonText: i18n.t('btn.ok'),
          cancelButtonText: i18n.t('btn.cancel')
        }).then((result) => {
          if (result.isConfirmed) {
            (async () => {
              for (const item of vm.selectedNotice) {
                let _url = `/onmapi/view/Notice/delete/${item}`;

                try {
                  await http.delete(_url);
                  console.info('Notice Delete Success !!', item);
                } catch (err) {
                  console.error('Notice Delete Error !!', err);
                }
              }

              vm.selectedNotice = [];
              await vm.getItems();

              await Swal.fire({
                icon: 'info',
                title: i18n.t('alert.deleted'),
                confirmButtonText: i18n.t('btn.close')
              });
            })();
          }
        })
      }
    }
  }
}
</script>

<style src='vue-multiselect/dist/vue-multiselect.min.css'></style>
